import {UI, type PartialOptions} from "../../../../../stem-core/ui/UIBase";
import {Merchant} from "../../../../../client/state/MerchantStore.js";
import {DonationOffer} from "../../../../../client/state/DonationOfferStore.js";
import {Donation} from "../../../../../client/state/DonationStore.js";
import {Toast} from "../../../../ui/Toast.jsx";
import {ConfirmationModal} from "../../../../ui/ConfirmationModal.jsx";
import {Messages} from "../../../../Messages.js";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {apiCancelDonation} from "../../../../../client/state/DonationStore.js";


interface CancelDonationModalOptions {
    donation?: Donation;
}

@autoredraw(Donation)
export class CancelDonationModal extends ConfirmationModal<CancelDonationModalOptions> {
    getDefaultOptions(): PartialOptions<CancelDonationModal> {
        const {donation} = this.options;
        const offer = DonationOffer.get(donation.recurringOfferId);
        const merchant = Merchant.get(offer.merchantId);
        return Object.assign({}, super.getDefaultOptions(), {
            title: Messages.cancelDonationTitle,
            description: Messages.cancelDonationDescription(merchant.name),
            confirmAction: () => this.cancel(),
            cancelLabel: Messages.close,
            confirmLabel: Messages.cancelDonation,
        });
    }

    async cancel() {
        const {donation} = this.options;

        if (!donation) {
            return;
        }

        try {
            await apiCancelDonation(donation);
            Toast.show(Messages.cancelDonationSuccess);
            this.hide();
        } catch (error) {
            Toast.showError(error);
            this.redraw();
        }
    }
}
